import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PageSeo } from '../components/PageSeo';
import { SubpageLayout } from '../components/SubpageLayout';

/**
 * Toplantılar — URL: /meetings
 */
export function ToplantilarPage() {
    const { t } = useTranslation();

    const defaultBullets = useMemo(() => {
        const raw = t('meetingsPage.defaultBullets', { returnObjects: true });
        return Array.isArray(raw) ? raw : [];
    }, [t]);

    const paragraphs = useMemo(() => {
        const raw = t('meetingsPage.paragraphs', { returnObjects: true });
        return Array.isArray(raw) ? raw : [];
    }, [t]);

    return (
        <>
            <PageSeo
                title={`${t('meetingsPage.title')} — ${t('header.rotaryAlt')}`}
                description={t('seo.meetings')}
            />
            <SubpageLayout
                title={t('meetingsPage.title')}
                subtitle={t('meetingsPage.subtitle')}
                contentClassName="meetings-page"
            >
            <div className="meetings-prose">
                <p className="meetings-lead mb-0">{t('meetingsPage.lead')}</p>
                <ul className="meetings-default-list list-unstyled mb-0">
                    {defaultBullets.map((line) => (
                        <li key={line} className="meetings-default-item">
                            {line}
                        </li>
                    ))}
                </ul>
                <p className="meetings-after-bullets mb-0">
                    {t('meetingsPage.afterBullets')}
                </p>
                {paragraphs.map((text, i) => (
                    <p key={i} className="meetings-prose-p mb-0">
                        {text}
                    </p>
                ))}
                <p className="meetings-rule-intro mb-0">
                    {t('meetingsPage.ruleIntro')}
                </p>
                <blockquote className="meetings-rule-quote mb-0">
                    <p className="mb-0">
                        “{t('meetingsPage.ruleQuote')}”
                    </p>
                </blockquote>
            </div>
        </SubpageLayout>
        </>
    );
}
